import React, { Component } from 'react';
import {
  Row, Col, Statistic,
} from 'antd';
import PropTypes from 'prop-types';
import autobind from 'react-autobind';
import translate from 'app/translations';
import { PROFILE_STEP_TYPES } from 'app/constants';
import bannerImg from 'assets/images/Man-holding-tablet.jpg';
import { formatNumberOrDash } from 'utils/format';
import AgentProfilePropType from '../AgentProfilePropType';
import WizardNav from './WizardNav';

export class LocalMarket extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  onNavigate(nextPage) {
    this.props.onSetAgentProfileStepRequest(nextPage);
  }

  render() {
    const { tat, srt } = this.props.agentProfile.slaTargets;

    return (
      <div>
        <div className="card-container responsive-border">
          <h2 className="orange-text">{this.t('LocalMarket.subHeading')}</h2>
          <Row
            type="flex"
            justify="space-around"
            align="middle"
            gutter={16}
          >
            <Col lg={24} xl={12}>

              <p>
                {this.t('LocalMarket.aboutSolidifi')}
              </p>
              <Row gutter={16} className="desktop-only align-center m-b-16">
                {!!tat && (
                  <Col xs={12}>
                    <Statistic
                      title={<span className="blue-text">{this.t('LocalMarket.turnaroundTime')}</span>}
                      value={formatNumberOrDash(tat, 1, '', 'days', '-')}
                    />
                  </Col>
                )}
                <Col xs={12}>
                  <Statistic
                    title={<span className="blue-text">{this.t('LocalMarket.revisionRate')}</span>}
                    value={formatNumberOrDash(srt, 0, '', '%', '-')}
                  />
                </Col>
              </Row>
              <p>
                {this.t('LocalMarket.competitive')}
                {!!tat && (
                  <strong>
                    {this.t('LocalMarket.targetTat', { tat })}
                  </strong>
                )}
                <strong>
                  {this.t('LocalMarket.targetSrt', { srt })}
                </strong>
              </p>
            </Col>
            <Col lg={24} xl={12} className="desktop-only">
              <img
                className=""
                src={bannerImg}
                alt={this.t('LocalMarket.manHoldingTablet')}
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
        </div>
        <WizardNav
          agentProfile={this.props.agentProfile}
          isCallInProgress={false}
          currentPage={PROFILE_STEP_TYPES.LOCAL_MARKET}
          onNavigate={this.onNavigate}
        />
      </div>
    );
  }
}

LocalMarket.propTypes = {
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
  onSetAgentProfileStepRequest: PropTypes.func.isRequired,
};

export default LocalMarket;
